import React, { useState } from "react";
import axios from "axios";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import AdminAppBar from "./AdminAppBar";
import './AddGuppyScreen.css';

const AddAquariumScreen = () => {
  const [aquarium, setAquarium] = useState({
    name: "",
    price: "",
    quantity: "",
    size: "",
    image: null,
    available: true,
  });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState("");
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
  const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file.size > 50000000) {
      setError("File size too large.");
    } else if (!file.type.startsWith("image/")) {
      setError("Only image files are allowed.");
    } else {
      setError("");
      setAquarium({ ...aquarium, image: file });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAquarium({ ...aquarium, [name]: value });
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", UPLOAD_PRESET);

    const uploadUrl = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

    try {
      const response = await axios.post(uploadUrl, formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });
      return response.data.secure_url;
    } catch (error) {
      console.error("Upload Error:", error);
      alert("Failed to upload image.");
      return null;
    }
  };

  const handleUpload = async () => {
    if (error) return alert(error);

    let imageUrl = "";
    if (aquarium.image) {
      imageUrl = await uploadToCloudinary(aquarium.image);
    }

    const data = {
      name: aquarium.name,
      price: parseFloat(aquarium.price || 0),
      quantity:parseFloat(aquarium.quantity || 0),
      size: aquarium.size,
      image: imageUrl,
      available: aquarium.available,
    };

    try {
      const collectionRef = collection(db, "aquariums");
      await addDoc(collectionRef, data);

      try {
        const webhookUrl = process.env.REACT_APP_N8N_ADD_PRODUCT_WEBHOOK_URL || process.env.REACT_APP_N8N_ADD_GUPPY_WEBHOOK_URL;
        if (webhookUrl) {
          const response = await fetch(webhookUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ ...data, itemType: "aquarium" }),
          });

          if (!response.ok) {
            console.error("n8n Webhook Error. Status:", response.status);
            alert("✅ تم حفظ الحوض في المتجر\n❌ تأكد من تفعيل Workflow في n8n، لم يتم النشر على فيسبوك!");
          } else {
            console.log("Aquarium info sent to n8n webhook successfully");
            alert("✅ تم إضافة الحوض بنجاح!\n✅ تم نشره على صفحة فيسبوك تلقائياً!");
          }
        } else {
          alert("✅ تم حفظ الحوض في المتجر");
        }
      } catch (webhookError) {
        console.error("Failed to send aquarium info to n8n webhook:", webhookError);
        alert("✅ تم حفظ الحوض في المتجر\n❌ حدث خطأ في الاتصال بسيرفر n8n للمنشورات!");
      }

      setAquarium({
        name: "",
        price: "",
        quantity: "",
        size: "",
        image: null,
        available: true,
      });
      setUploadProgress(0);
      setFileInputKey(Date.now());
    } catch (err) {
      console.error("Failed to upload:", err);
      alert("Failed to save aquarium.");
    }
  };

  return (
    <div>
      <AdminAppBar />
      <div className="page-container">
        <h1 className="title">إضافة حوض جديد</h1>
        {error && <p className="error-message">{error}</p>}

        <div className="input-card">
          <label className="label">📸 صورة الحوض</label>
          <input key={fileInputKey} type="file" accept="image/*" onChange={handleFileChange} className="input-field" />

          <label className="label">📛 اسم الحوض</label>
          <input type="text" name="name" value={aquarium.name} onChange={handleInputChange} className="input-field" />

          <label className="label">💰 السعر</label>
          <input type="number" name="price" value={aquarium.price} onChange={handleInputChange} className="input-field" />
          <label className="label">الكمية</label>
          <input type="number" name="quantity" value={aquarium.quantity} onChange={handleInputChange} className="input-field" />


          <label className="label">📏 الحجم (مثلاً 40 لتر)</label>
          <input type="text" name="size" value={aquarium.size} onChange={handleInputChange} className="input-field" />

          <button onClick={handleUpload} className="upload-button">💾 حفظ الحوض</button>
          {uploadProgress > 0 && (
            
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${uploadProgress}%` }}></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddAquariumScreen;
